type Handler<T = any> = (val: T) => void;

class EventBus<Events extends Record<string, any>> {
  private map: Map<string, Set<Handler>> = new Map();

  /**
   * emit a event
   * @param name eventName
   * @param handler eventHandler
   */
  on<EventName extends keyof Events> (
    name: EventName,
    handler: Handler<Events[EventName]>
  ) {
    let set: Set<Handler<Events[EventName]>> | undefined = this.map.get(
      name as string
    );
    if (!set) {
      set = new Set();
      this.map.set(name as string, set);
    }
    set.add(handler);
  }

  /**
   * trigger event
   * @param name eventName
   * @param handler eventHandler
   */
  emit<EventName extends keyof Events> (
    name: EventName,
    value: Events[EventName]
  ) {
    const set: Set<Handler<Events[EventName]>> | undefined = this.map.get(
      name as string
    );
    if (!set) return;
    const copied = [...set];
    copied.forEach((fn) => fn(value));
  }

  /**
   *  clear events
   */
  off(): void;
  /**
   * clear the same named event
   * @param name eventName
   */
  off<EventName extends keyof Events>(name: EventName): void;
  /**
   * clear a event
   * @param name eventName
   * @param handler eventHandler
   */
  off<EventName extends keyof Events>(
    name: EventName,
    handler: Handler<Events[EventName]>
  ): void;

  off<EventName extends keyof Events> (
    name?: EventName,
    handler?: Handler<Events[EventName]>
  ): void {
    if (!name) {
      this.map.clear();
      return;
    }

    if (!handler) {
      this.map.delete(name as string);
      return;
    }

    const handlers: Set<Handler<Events[EventName]>> | undefined = this.map.get(
      name as string
    );
    if (!handlers) {
      return;
    }
    handlers.delete(handler);
  }
}

const eventBus = new EventBus<{
  [key: string]: any
}>();

export default eventBus;
